import { useState, useEffect } from 'react';

export default function useWindowDimensions() {
  const getDimensions = () => {
    return typeof window === 'undefined'
      ? { width: null, height: null }
      : {
          width: window.innerWidth,
          height: window.innerHeight,
        };
  };

  const [dimensions, setDimensions] = useState(getDimensions());

  useEffect(() => {
    const handleResize = () => {
      setDimensions(getDimensions());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return dimensions;
}
